<template>
    <div>
        <div class="widget-title">
            {{ title }}
        </div>
        <div class="widget-amounts">
            <div class="current-amount">
                {{ amount | money }} {{ currency | currency }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReminderAmountWidget",

    props: ['title', 'data'],

    computed: {
        amount() {
            return this.data.value ? this.data.value : 0
        },

        currency() {
            return this.data.currency ? this.data.currency : 0
        }
    }
}
</script>

<style lang="scss" scoped>

</style>